import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  responseChartAddId: "",
  personSelected: [],
};
/**========================================================================
 *                             Reducer
 *
 *
 *
 *
 *========================================================================**/
const responseAdd = (state, action) => {
  state.responseChartAddId = action.payload;
};
const personSelectAdd = (state, action) => {
  const newData = action.payload;
  const prevData = [...state.personSelected];
  const isIdExist = prevData.some((item) => item.id === newData.id);
  if (!isIdExist) {
    if(isIdExist !==null){

      state.personSelected.push(newData);
    }
  }
};
const personSelectRemove = (state, action) => {
  const newData = action.payload;
  const prevData = [...state.personSelected];
  const updateList = prevData.filter((item) => item.id !== newData.id)
   state.personSelected=updateList
};
const personSelectClear=(state)=>{
  state.personSelected=[]
}
const ChartSlice = createSlice({
  name: "chart",
  initialState,
  reducers: {
    responseAdd,
    personSelectAdd,
    personSelectRemove,
    personSelectClear
  },
});

export const {
  responseAdd: responseAddR,
  personSelectAdd: personSelectAddR,
  personSelectRemove: personSelectRemoveR,
  personSelectClear:personSelectClearR
} = ChartSlice.actions;

export default ChartSlice.reducer;
